import React, { ReactNode, RefObject, useRef, useState } from 'react';
import { getPageThemeFromUrl, getVerifyLayout, pageThemeEnum } from './helpers';

export type VerifyLayoutProps = {
  children: ReactNode;
  isBlankLayout?: boolean;
  pageTheme?: string;
};

export const loggingInMessage = 'Logging you in...';

export const VerifyLayoutProvider = ({ children, isBlankLayout }: VerifyLayoutProps): JSX.Element => {
  const pageTheme = useRef(getPageThemeFromUrl(window.location.href));
  const [loadingMessage, setLoadingMessage] = useState<string>(loggingInMessage);
  const [themeContext, setThemeContext] = useState<Record<string, any>>({});
  const ThemeLayout = getVerifyLayout(isBlankLayout ? pageThemeEnum.perksSuccess : pageTheme.current);

  return (
    <VerifyLayout.Provider
      value={{
        pageTheme,
        loadingMessage,
        setLoadingMessage,
        themeContext,
        setThemeContext: setThemeContext,
      }}
    >
      <ThemeLayout>{children}</ThemeLayout>
    </VerifyLayout.Provider>
  );
};

export type VerifyLayout = {
  pageTheme: RefObject<pageThemeEnum>;
  themeContext: Record<string, any>;
  setThemeContext: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  loadingMessage: string;
  setLoadingMessage: React.Dispatch<React.SetStateAction<string>>;
};

export const VerifyLayout = React.createContext<VerifyLayout | null>(null);

export const useVerifyLayout = (): VerifyLayout => {
  const defaultContext = {
    pageTheme: { current: pageThemeEnum.default },
    loadingMessage: '',
    setLoadingMessage: () => null,
    themeContext: {},
    setThemeContext: () => null,
  };

  return React.useContext(VerifyLayout) ?? defaultContext;
};
